module.exports = __webpack_public_path__ + "static/media/andre-oliveira.c2bdbf1b.png";